import React, { createContext, useState, useEffect, useContext } from "react";
import { fetchProducts, fetchActiveOffers } from "../../services/pos/Tables";
import {
  getFavoriteProducts,
  addFavoriteProducts,
  removeFavoriteProducts,
} from "../../services/pos/FavoriteProducts";
import { useAuth } from "../AuthContext"; // عدّل المسار حسب مشروعك


const ProductContext = createContext({
  products: [],
  offers: [],
  favorites: [],
  favoritesLoading: true,
  loading: true,
  error: null,
  refresh: () => {},
  addToFavorites: async () => {},
  removeFromFavorites: async () => {},
});

export const ProductProvider = ({ children }) => {
  const { isAuthenticated } = useAuth(); // ✅ مهم جدًا
  const [products, setProducts] = useState([]);
  const [offers, setOffers] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [favoritesLoading, setFavoritesLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    setFavoritesLoading(true);
    try {
      const [productsData, offersData, favData] = await Promise.all([
        fetchProducts(),
        fetchActiveOffers(),
        getFavoriteProducts(),
      ]);

      setProducts(Array.isArray(productsData) ? productsData : []);
      setOffers(Array.isArray(offersData) ? offersData : []);

      // favData may be an array (returned data.data) or an object { data: [...] }
      const favItems = Array.isArray(favData)
        ? favData
        : Array.isArray(favData?.data)
        ? favData.data
        : [];

      const favProducts = favItems.length > 0 ? favItems.map((item) => item.product).filter(Boolean) : [];
      setFavorites(favProducts);
    } catch (err) {
      setError(err);
      setProducts([]);
      setOffers([]);
      setFavorites([]);
    } finally {
      setLoading(false);
      setFavoritesLoading(false);
    }
  };

  // أضف منتجات إلى المفضلة. يمكن تمرير مصفوفة أو كائن واحد.
  const addToFavorites = async (favoritesPayload = []) => {
    const payload = Array.isArray(favoritesPayload)
      ? favoritesPayload
      : [favoritesPayload];

    // تحديث متفائل للمفضلات محلياً لعرض التغيير فوراً
    setFavorites((prev) => {
      const next = [...prev];
      payload.forEach((p) => {
        const prodId = Number(p.product_id);
        if (!next.some((f) => Number(f.id) === prodId)) {
          const prod = products.find((pr) => Number(pr.id) === prodId);
          next.push(prod || { id: prodId });
        }
      });
      return next;
    });

    try {
      const res = await addFavoriteProducts(payload);
      // إعادة جلب المفضلات من السيرفر للتأكد من الاتساق
      const favData = await getFavoriteProducts();
      const favItems = Array.isArray(favData) ? favData : favData?.data ?? [];
      const favProducts = Array.isArray(favItems) ? favItems.map((item) => item.product).filter(Boolean) : [];
      setFavorites(favProducts);
      return res;
    } catch (e) {
      // عند الخطأ: حاول إعادة جلب المفضلات لتصحيح الحالة المحلية
      try {
        const favData = await getFavoriteProducts();
        const favItems = Array.isArray(favData) ? favData : favData?.data ?? [];
        const favProducts = Array.isArray(favItems) ? favItems.map((item) => item.product).filter(Boolean) : [];
        setFavorites(favProducts);
      } catch (_){ /* ignore */ }
      throw e;
    }
  };
 
  // إزالة منتجات من المفضلة. يمكن تمرير مصفوفة أو كائن واحد.
  const removeFromFavorites = async (favoritesPayload = []) => {
    const payload = Array.isArray(favoritesPayload)
      ? favoritesPayload
      : [favoritesPayload];
    // تحديث متفائل: ازالة من الحالة محلياً فوراً
    setFavorites((prev) =>
      prev.filter((f) => !payload.some((p) => Number(p.product_id) === Number(f.id)))
    );

    try {
      const res = await removeFavoriteProducts(payload);
      // إعادة جلب للتأكد من التوافق
      const favData = await getFavoriteProducts();
      const favItems = Array.isArray(favData) ? favData : favData?.data ?? [];
      const favProducts = Array.isArray(favItems) ? favItems.map((item) => item.product).filter(Boolean) : [];
      setFavorites(favProducts);
      return res;
    } catch (e) {
      // عند الخطأ: إعادة جلب لتصحيح الحالة المحلية
      try {
        const favData = await getFavoriteProducts();
        const favItems = Array.isArray(favData) ? favData : favData?.data ?? [];
        const favProducts = Array.isArray(favItems) ? favItems.map((item) => item.product).filter(Boolean) : [];
        setFavorites(favProducts);
      } catch (_){ /* ignore */ }
      throw e;
    }
  };
  
useEffect(() => {
  if (!isAuthenticated ) return; // ⛔ امنع النداء قبل تسجيل الدخول
  loadData();
}, [isAuthenticated ]);

  return (
    <ProductContext.Provider
      value={{
        products,
        offers,
        favorites,
        favoritesLoading,
        loading,
        error,
        refresh: loadData,
        addToFavorites,
        removeFromFavorites,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProductsOffers = () => useContext(ProductContext);
